import { ContentStat } from "seneca-common/features/stats/state";
import { chooseMFromN } from "seneca-common/utils/functions";

import lastAttemptIncorrect from "../../../utils/logic/lastAttemptIncorrect";
import { GenerateContentOptions } from "../../types";
import { getTestableWordsInfo } from "../selectors";
import { Content, TestableSentence, WordfillContentSource } from "../types";

export function generateContent(
  source: WordfillContentSource,
  { testingActive, maxDifficulty }: GenerateContentOptions,
  contentStat?: ContentStat
): Content {
  const renderImage = Boolean(source.imageURL) && Math.random() >= 0.5;
  if (!testingActive) return { ...source, renderImage };

  const words = copyWords(source.words);
  const testableWords = getTestableWordsInfo({
    words
  } as Content);
  const toTest = getMaxTested(contentStat, maxDifficulty, testableWords.length);

  const testedIndexes = chooseMFromN(toTest, testableWords.length);
  testedIndexes.forEach(index => (testableWords[index].testing = true));

  return { ...source, words, renderImage };
}

export const MAX_TO_TEST = 4;

function getMaxTested(
  meta: ContentStat | null | undefined,
  maxDifficulty: boolean | null | undefined,
  testableWords: number
): number {
  if (maxDifficulty) return testableWords;

  let maxTested;
  const deduction = lastAttemptIncorrect(meta) ? 1 : 0;

  if (!meta || meta.timesStudied < 2) {
    maxTested = 1;
  } else if (meta.timesStudied < 4) {
    maxTested = 2;
  } else if (meta.timesStudied < 6) {
    maxTested = 3;
  } else {
    maxTested = MAX_TO_TEST;
  }

  maxTested = Math.min(maxTested, testableWords);

  return Math.max(1, maxTested - deduction);
}

export function copyWords(sourceWords: TestableSentence): TestableSentence {
  let newWords: any[] = [];

  for (let i = 0; i < sourceWords.length; i++) {
    if (!newWords[i]) {
      if (typeof sourceWords[i] === "string") {
        newWords[i] = sourceWords[i];
      } else {
        // @ts-ignore
        newWords[i] = { ...sourceWords[i] };
      }
    }
  }

  return newWords;
}
